<template>
  <div class="yx-predicted-page main-layout predicted-item-page" v-loading="handleLoading">
    <el-card shadow="never" class="box-form box-inner box-bg">
      <c-title slot="header" title="奖励处分"></c-title>
      <div class="pb90">
        <div class="div-scroll">
          <el-form
            size="small"
            :model="handleData"
            ref="cForm"
            :rules="formRules"
            label-position="top"
            style="width: 60%; margin: 0 auto; padding-top: 40px"
            :disabled="disabled"
          >
            <div class="tips-container">
              <div class="tips">
                <div class="title">
                  <i class="el-icon-info"></i><span>温馨提示</span>
                </div>
                <p>
                  1、填写个人奖励处分信息；如：2020年在**市一中荣获市数学竞赛一等奖；
                </p>
                <p>2、内容限制50字以内；</p>
                <p>
                  注：填写的内容将纳入个人档案，请谨慎填写确保信息真实有效。
                </p>
              </div>
            </div>
            <el-form-item label="何时、何地受过何种奖励：" prop="award">
              <el-input
                :rows="8"
                v-model="handleData.award"
                type="textarea"
                maxlength="50"
                show-word-limit
                placeholder="请输入何时、何地受过何种奖励,50字以内"
              ></el-input>
            </el-form-item>
            <el-form-item label="何时、何地受过何种处分：" prop="punish">
              <el-input
                :rows="8"
                v-model="handleData.punish"
                type="textarea"
                maxlength="50"
                show-word-limit
                placeholder="请输入何时、何地受过何种处分,50字以内"
              ></el-input>
            </el-form-item>

            <el-form-item label-width="0">
              <div style="text-align: center; padding-top: 20px">
                <el-button
                  type="primary"
                  class="leave-btn"
                  @click="submit"
                  :disabled="disabled"
                  >提交</el-button
                >
              </div>
            </el-form-item>
          </el-form>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapState } from "vuex";
import MHandle from "@/mixins/MHandle.js";
let mHandle = MHandle({
  handleGetPath: "",
  handleGetPathNoparam: "/account/base/student/award/myInfo",
  handleInsertPath: "/account/base/student/award/save",
  handleUpdatePath: "/account/base/student/award/update",
  handleDownLoadPath: "",
  handleData: {},
});

export default {
  mixins: [mHandle],
  data() {
    return {
      formRules: {
        award: [
          {
            required: true,
            trigger: "blur",
            message: "请输入何时、何地受过何种奖励",
          },
        ],
        punish: [
          {
            required: true,
            trigger: "blur",
            message: "请输入何时、何地受过何种处分",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState("dic", ["SUCCESS_CODE"]),
    disabled() {
      let status = this.$route.params.status;
      return status == 2 ? true : false;
    },
  },
  created() {},
  mounted() {
    this.getInfo(); //查询个人信息
  },
  methods: {
    // 获取学生到校信息
    getInfo() {
      this.$http.get("/account/base/student/award/myInfo").then((res) => {
        // console.log(res);
        if (res.code == this.SUCCESS_CODE) {
          if (res.data) this.handleData = res.data;
        } else {
          this.$message.error(`${res.msg}`);
        }
      });
    },
    submit() {
      this.$refs["cForm"].validate((valid) => {
        if (valid) {
          this.$confirm("请确认无误后提交，是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }).then(() => {
            if (this.handleData.id) {
              this.handleUpdate();
            } else {
              this.handleInsert();
            }
          });
        }
      });
    },
  },
};
</script>

